<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="选择门店" prop="storeCode">
            <el-select v-model="form.storeCode" placeholder="请选择" :filterable="true" @change="storeChange">
              <el-option
                v-for="item in storeOptions"
                :key="item.storeCode"
                :label="item.storeName"
                :value="item.storeCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="form.phone" prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="建议" prop="suggestion">
            <el-input type="textarea" v-model="form.suggestion" :rows="5" :maxlength="300"
                      show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button :loading="isSubmitting" type="primary" @click="onSubmit" style="text-align: center;border-radius: 5px;width: 100%;">
      <span v-if="isSubmitting">提交中</span>
      <span v-else>提交</span>
    </el-button>
  </div>
</template>

<script>
import { appendComplaintFormFields } from '../utils/complaintSubmit'

export default {
  name: 'App',
  props: {
    deptcode: {type: String},
    mpSession: {type: String, default: ''},
  },
  data() {
    return {
      storeOptions: [],
      form: {},
      rules: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: '请输入正确的号码格式',
            trigger: 'blur'
          }
        ],
        storeCode: [
          {required: true, message: '请选择门店', trigger: 'blur'}
        ],
        suggestion: [
          {required: true, message: '请输入建议', trigger: 'blur'}
        ],
      },
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      isSubmitting: false
    }
  },
  created() {
    this.getComplaintStoreList()
    if (this.deptcode){
      this.form.storeCode = this.deptcode
    }
  },
  methods: {
    storeChange(value) {
      // 1、使用循环方式获取storeName
      this.storeOptions.forEach(item => {
        if (item.storeCode === value) {
          this.form.storeName = item.storeName;
        }
      })
      // // 2、使用数组的find方法获取storeName
      // // 数组实例的find方法用于找出第一个符合条件的数组成员
      // const store =  this.storeOptions.find(item => item.storeCode === value);
      // this.form.storeName = store.storeName;
    },
    getComplaintStoreList() {
      this.$http.get('/complaintStore').then(res => {
        if (String(res.code) === '1') {
          this.storeOptions = res.data
        }
      }).catch(() => {
        return this.$message.error("获取门店数据失败")
      })
    },
    onSubmit() {
      // 1、使用循环方式获取storeName
      this.storeOptions.forEach(item => {
        if (item.storeCode === this.form.storeCode) {
          this.form.storeName = item.storeName;
        }
      })
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.isSubmitting = true
          // 创建一个 FormData 对象来存储要发送的数据
          const formData = new FormData();
          appendComplaintFormFields(formData, this.form, '0', this.mpSession, this.$route && this.$route.query)
          const res = await this.$http.post('/complaint', formData)
          if (String(res.code) === '1') {
            this.isSubmitting = false
            this.$message.success("感谢您的提交 会在24小时内回复处理！")
            setTimeout(()=>{
              // 刷新页面
              location.reload()
            },1000)
          }else{
            this.isSubmitting = false
            return this.$message.error('提交失败，请稍后再试');
          }
        }
      })
    },
    onBack() {
      this.$router.push('/')
    }
  }
}
</script>

<style>
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 8px;
}
.el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SuggestionForm.vue